
/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library
import PropTypes from 'prop-types' // Npm: prop-types library.
import { useQuery } from '@apollo/client' // Npm: Apollo client.


/*
 * PACKAGES
 */
import { MemoizedSelect } from 'components/MemoizedInput'


/*
 * GRAPHS
 */
import VendorReadQuery from './__query__/index.vendor.read.query'


/*
 * OBJECTS
 */
const Index = ({ onChange, ...props }) => {
  // Const assignment.
  const _skipDifference = 10000

  // Hook assignment.
  const _QueryVendorRead = useQuery(VendorReadQuery, { 'variables': { 'take': _skipDifference, 'skip': 0 }, 'fetchPolicy': Object.React.App.fetchPolicy, 'pollInterval': Object.React.App.pollInterval })

  // Return component.
  return (
    <MemoizedSelect
      onChange={onChange}
      options={_QueryVendorRead?.data?.VendorRead?.map(({ id, displayName }) => `${displayName} (${id})`)}
      isRequired={true}
      {...props}
    />
  )
}


/*
 * PROPTYPES
 */
Index.propTypes = {
  'onChange': PropTypes.func.isRequired,
}


/*
 * EXPORT
 */
export default Index
